import React from "react";

import Text from "src/components/text";
import { SearchTagItem } from "src/types/reports";

import styles from "./searchTagsListItem.module.scss";

export interface SearchTagsListItemProps {
  item: SearchTagItem;
  columnCount: number;
}

export const SearchTagsListItem: React.FC<SearchTagsListItemProps> = ({
  item,
  columnCount,
}) => {
  return (
    <div key={item.id} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <div className={styles.queryItem}>
          <div className={styles.queryNumber}>{item.manualIndex}</div>
        </div>
        <a
          href={`/search/assets?tags=${item.key}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text
                text={item.key || ""}
                lines={1}
                className={styles.searchTags}
              />
            </div>
          </div>
        </a>
      </div>

      <div className={styles.metricsData}>
        <div
          className={styles.analyticsContainer}
          style={{ gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))` }}
        >
          <div className={styles.tableDataViews}>
            <span>{item.assetCount || 0}</span>
          </div>
          <div className={styles.tableDataViews}>
            <span>{item.searchCount || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
